import { useTheme } from './context/theme-provider';

export function Logo({ ignoreTheme = false, className }: { ignoreTheme?: boolean; className?: string }) {
  const { theme } = useTheme();
  const isDark = theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);

  if (isDark && !ignoreTheme) {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='40' height='40' className={className}>
        <defs>
          <filter id='glow5' x='-20%' y='-20%' width='140%' height='140%'>
            <feGaussianBlur stdDeviation='8' result='blur' />
            <feComposite in='SourceGraphic' in2='blur' operator='over' />
          </filter>
          <filter id='glowStrong5' x='-20%' y='-20%' width='140%' height='140%'>
            <feGaussianBlur stdDeviation='12' result='blur' />
            <feComposite in='SourceGraphic' in2='blur' operator='over' />
          </filter>
        </defs>
        <rect width='512' height='512' fill='#141210' />
        <rect
          x='40'
          y='40'
          width='432'
          height='432'
          fill='none'
          stroke='hsl(40, 60%, 58%)'
          strokeWidth='6'
          filter='url(#glowStrong5)'
          opacity='0.7'
        />
        <rect
          x='62'
          y='62'
          width='388'
          height='388'
          fill='none'
          stroke='hsl(40, 60%, 58%)'
          strokeWidth='4'
          filter='url(#glowStrong5)'
          opacity='0.7'
        />
        <g stroke='hsl(40, 60%, 58%)' strokeWidth='28' strokeLinecap='round' fill='none' filter='url(#glow5)'>
          <line x1='145' y1='115' x2='145' y2='397' />
          <line x1='210' y1='115' x2='210' y2='397' />
          <line x1='275' y1='115' x2='275' y2='397' />
          <line x1='340' y1='115' x2='340' y2='397' />
          <line x1='110' y1='350' x2='375' y2='150' />
        </g>
      </svg>
    );
  }

  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='40' height='40' className={className}>
      <defs>
        <filter id='glow6' x='-20%' y='-20%' width='140%' height='140%'>
          <feGaussianBlur stdDeviation='6' result='blur' />
          <feComposite in='SourceGraphic' in2='blur' operator='over' />
        </filter>
      </defs>
      <rect width='512' height='512' fill='#f5f0ea' />
      <rect x='40' y='40' width='432' height='432' fill='none' stroke='hsl(40, 45%, 40%)' strokeWidth='6' opacity='0.8' />
      <rect x='62' y='62' width='388' height='388' fill='none' stroke='hsl(40, 45%, 40%)' strokeWidth='4' opacity='0.8' />
      <g stroke='hsl(40, 45%, 40%)' strokeWidth='28' strokeLinecap='round' fill='none'>
        <line x1='145' y1='115' x2='145' y2='397' />
        <line x1='210' y1='115' x2='210' y2='397' />
        <line x1='275' y1='115' x2='275' y2='397' />
        <line x1='340' y1='115' x2='340' y2='397' />
        <line x1='110' y1='350' x2='375' y2='150' />
      </g>
    </svg>
  );
}
